export enum FileType {
  Quote = 'quotePdf',
  Lead = 'leadPdf',
}
